// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"scaled-image_wrapper__lkSib","styledImage":"scaled-image_styledImage__sn6XV"};